import React from "react"
import { Radium } from "higher-order-components"
import { Button } from "AtomicComponents"
import PropTypes from "prop-types"
import MyMazdaVehicleTile from "./vehicle-tile"

const MyMazdaVehicleList = ({
  vehicles,
  dashboardButtonText,
  nextServiceDisclaimer,
  removeOnClick
}) => (
  <div style={styles.list}>
    {vehicles.map(({ dashboardUrl, disabled, ...vehicle }, index) => (
      <div key={vehicle.vin} style={{ margin: ".5em" }}>
        <MyMazdaVehicleTile
          cta={
            <Button
              disabled={disabled}
              styleName={"black"}
              href={dashboardUrl}
              fullWidth
            >
              {dashboardButtonText}
            </Button>
          }
          nextServiceDisclaimer={nextServiceDisclaimer}
          removeOnClick={() => removeOnClick(index)}
          index={index}
          disabled={disabled}
          {...vehicle} />
      </div>
    ))}
  </div>
)

MyMazdaVehicleList.propTypes = {
  disabled: PropTypes.bool,
  vehicles: PropTypes.arrayOf(
    PropTypes.shape(MyMazdaVehicleTile.propTypes)
  ).isRequired,
  dashboardButtonText: PropTypes.string,
  nextServiceDisclaimer: PropTypes.string,
  removeOnClick: PropTypes.func
}

const styles = {
  list: {
    display: "flex",
    margin: "3em 0",
    justifyContent: "center",
    flexWrap: "wrap"
  }
}

export default Radium(MyMazdaVehicleList)




// WEBPACK FOOTER //
// ./src/components/mymazda/vehicle-list/index.jsx